import { _auth } from "./_auth";
import { _user } from "./_user";
// console.log(_auth);
export const User_MODULE = {
  namespaced: true,
  getters: {},
  modules: {
    _auth,
    _user
  }
};
